import { createFileRoute, Outlet } from "@tanstack/react-router";

// Section layout for the students surface (portal's `_protected.$school.students`). Renders only an
// Outlet; the overview child owns the page chrome.
export const Route = createFileRoute("/$locale/{-$schoolyear}/_authenticated/$school/students")({
  component: () => <Outlet />,
});
